import { render, staticRenderFns } from "./ColumnV1.vue?vue&type=template&id=790a6e24&scoped=true&"
import script from "./ColumnV1.vue?vue&type=script&lang=js&"
export * from "./ColumnV1.vue?vue&type=script&lang=js&"
import style0 from "./ColumnV1.vue?vue&type=style&index=0&id=790a6e24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790a6e24",
  null
  
)

export default component.exports